import { useState } from "react";
import { isLogin } from "services/LocalStorage/LocalStorage.service";
import { useDispatch } from "react-redux";
import { AppDispatch } from "store";
import { rateArticle } from "store/userArticle/userArticle.slice";
import { showToast } from "utils/helpers/toastHelper";
import { useNavigate } from "react-router-dom";
import { Rate, Tooltip } from "antd";
import { HeartFilled, HeartOutlined, StarOutlined } from "@ant-design/icons";
import "./FavoriteButtonComponent.scss";

const FavoriteButtonComponent = ({ slug, currentFavorite }: any) => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const [favorite, setFavorite] = useState(
    currentFavorite ? currentFavorite : false
  );
  const handleFavorite = (slug: string, liked: boolean) => {
    if (isLogin()) {
      dispatch(rateArticle({ data: { is_favorite: !liked }, slug: slug })).then(
        (res: any) => {
          if (res.meta.requestStatus === "fulfilled") {
            showToast(res.payload.data, "success");
            setFavorite(!liked);
          }
        }
      );
    } else {
      showToast(`Niste ulogovani`, "warn");
      navigate("/login");
    }
  };
  return (
    <Tooltip title={favorite ? "Izbaci iz omiljenih" : "Dodaj u omiljene"}>
      <button
        className="Favorite-Button"
        onClick={() => handleFavorite(slug, favorite)}
      >
        {favorite ? <HeartFilled /> : <HeartOutlined />}
      </button>
    </Tooltip>
  );
};

export default FavoriteButtonComponent;
